import { initLogging } from "@expert/logging";
import { getFullStoryUrlSync } from "@expert/monitoring";

import { env } from "./utils/env";

initLogging({
    appName: env.appName,
    commitHash: env.commitHash,
    logLevel: env.logLevel,
    mixin: () => ({ fullStoryUrl: getFullStoryUrlSync() ?? "not defined" }),
});
